/**
 *
 * @fileoverview AuthenticationService
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
 */

import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { User } from '@shared/models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  authState = new BehaviorSubject(false);

  constructor(private nav: NavController) {
    this.ifLoggedIn();
  }

  ifLoggedIn() {
    if (localStorage.getItem('profile')) {
      this.authState.next(true);
    }
  }

  token(token: string) {
    localStorage.setItem('token', token);
    this.authState.next(true);
  }

  profile(profile: User, mode: string = '') {
    localStorage.setItem('profile', JSON.stringify(profile));
    localStorage.setItem('mode', mode);
    this.authState.next(true);
  }

  login(route: string = 'home') {
    this.nav.navigateRoot(route);
  }

  logout() {
    localStorage.clear();
    this.authState.next(false);
  }

  isAuthenticated() {
    const authState: boolean = this.authState.value;
    if (!authState) {
      this.nav.navigateForward('welcome');
    }
    return authState;
  }
}
